import type { Product } from '@@partner:types:app'

import React from 'react'
import {
  getWeightPostfix,
  isWeightProduct,
  formatWeight
} from '@@partner:helpers/product'

export interface ProductPackageInfoProps {
  product: Product
}

const ProductPackageInfo: React.FC<ProductPackageInfoProps> = ({ product }) => {
  const pkgInfo = product.pkg
  const weightInfo = `${product.min_count} ${getWeightPostfix(product)}`
  const pieceInfo = `${formatWeight(product)} (в упаковке)`

  return (
    <h6>{pkgInfo || (isWeightProduct(product) ? weightInfo : pieceInfo)}</h6>
  )
}

export default React.memo(ProductPackageInfo)
